export default "__VITE_ASSET__qJXcFz8f__"